import styled from "styled-components";
import { Button, colors, typography } from "@streeteasy/design-system";

import { agentIcon } from "../../assets";

export const Container = styled.div`
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GRAY_LIGHT};
  padding: 20px 31px 20px 20px;
  text-align: left; // overwrite external styling
`;

export const Title = styled(typography.H6)``;

export const Text = styled(typography.P)``;

export const ContactAgentButton = styled(Button)`
  margin-top: 10px;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const CTAImage = styled.img.attrs({
  role: "presentation",
  src: agentIcon
})`
  border-radius: 50%;
  height: 56px;
  margin-left: 20px;
  width: 56px;
`;
